import $command from '@/utils/command'
import globalActions from '@/actions'
import { Loading } from 'element-ui'
import md5 from "md5";
const state = {
	identity: {
		data:null
	},
	menu: {
		tree: [],
		list: [],
		current: {},
		root: {},
		subMenuVisable: true
	}, 
	feature: {
		ids: [],
		keys: []
	}
}
const mutations = {
	
	updateIdentity: (state, data) => {
		state.identity.data = data
		globalActions.setGlobalState({
			identity: state.identity
		});
	},
	updateTree: (state, data) => {
		state.menu.tree = data
		globalActions.setGlobalState({
			menu: state.menu
		});
	},
	updateList: (state, data) => {
		state.menu.list = data
		globalActions.setGlobalState({
			menu: state.menu
		});
	},
	updateCurrent: (state, data) => {
		state.menu.current = data

		let root = data;

		if (data.parents && data.parents.length > 0) {
			root = data.parents[data.parents.length - 1]
		}
		state.menu.root = root
		globalActions.setGlobalState({
			menu: state.menu
		});
	},
	updateFeature: (state, data) => {
	  state.feature.ids = data.ids
	  state.feature.keys = data.keys
	  
	  globalActions.setGlobalState({
		  feature: state.feature
	  });
	}
}
const actions = {
	async get({
		commit
	}, notNeedLogin) {
		if (state.identity.data == null) {
			const result = await $command.execute({
				api: "/core-merch-api/sys/getIdentity",
				parameter: {},
				notNeedLogin
			})
			if (result.code != 0) {
				return false
			}
			//初始化商户数据
			if (result.data.initMerchant === 0) {
				const loading = Loading.service({
					lock: true,
					text: '正在初始化',
					spinner: 'el-icon-loading'
				});
				await $command.execute({
					api: "/core-merch-api/sys/initializeMerchant",
					parameter: {}
				});
				result.data.initMerchant = 1
				loading.close();
			}
			result.data.racl = 0
			if (result.data.merchantConfig) {
				try {
					let config = JSON.parse(result.data.merchantConfig)
					result.data.racl = config.racl
				} catch {

				}
			}
			let identity = result.data
			//更新identity
			localStorage.setItem("identity", identity.identity);
			sessionStorage.setItem("racl.identity", JSON.stringify(identity));
			commit('updateIdentity', identity)
			let racl = identity.racl
			//菜单
			const menuResult = await $command.execute({
				//api: "/core-merch-api/sys/getMenu",
				api:(identity.racl == 1? "/racl-merch-api/racl/getMenu":"/core-merch-api/sys/getMenu"),
				parameter: {},
				notNeedLogin
			})
			if(menuResult.code != 0){
				return false
			}
			
			let root = menuResult.data;
			let tree = root.items;
			let list = [];
			toList(list, root)//将树型结构转换成列表结构
			setParent(list);  //设置各个节点的父节点
			sessionStorage.setItem("racl.menu.tree", JSON.stringify(tree));
			sessionStorage.setItem("racl.menu.list", JSON.stringify(list));
			commit('updateTree', tree)
			commit('updateList', list)

			const featrueResult = await $command.execute({
				api: (identity.racl == 1? "/racl-merch-api/racl/getAccessorResourceList":"/core-merch-api/sys/getRoleFeatureList"),
				parameter: {},
				notNeedLogin
			})
			if(featrueResult.code != 0){
				return false
			}
			let ids  = [];
			let keys = [];
			if(identity.racl == 1){
				featrueResult.data.forEach(e=>{
					ids.push(e.id)
					keys.push(e.key)
				})
			}else{
				featrueResult.data.forEach(e=>{
					ids.push(e.key)
					keys.push(e.value)
				})
			}
			sessionStorage.setItem("racl.feature", JSON.stringify({ids, keys}));
			commit('updateFeature',{ids, keys})
		}
		return state
	},
}
function setParent(list) {
	list.forEach(node => {
		node.parents = [];
		let pid = node.parentId
		while (pid != 0) {
			var parentArr = list.filter(item => item.id === pid);
			if (parentArr && parentArr.length > 0) {
				parent = parentArr[0]
				node.parents.push(parent)
				pid = parent.parentId
			}
		}
	})
}

function toList(list, tree) {
	if(tree.url && tree.url != '#' && tree.url.indexOf('http') == -1){
		tree.url += (tree.url.indexOf('?')> 0 ?"&":"?")
		tree.url += `sid=${tree.id}`
		//let sign = md5(tree.url + state.identity.data.identity)
		//tree.url += `&sign=${sign}`
	}
	list.push({
		feature: tree.feature,
		icon: tree.icon,
		id: tree.id,
		name: tree.name,
		parentId: tree.parentId,
		url: tree.url,
		items: tree.items
	})
	if (tree.items && tree.items.length > 0) {
		tree.items.forEach(e => {
			toList(list, e)
		})
	}
}

export default {
	namespaced: true,
	mutations,
	state,
	actions
}